import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Layout, { Card, Label, Spinner } from "../components/Layout";
import { CaretDown, Question, BookOpen, ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function FAQ() {
  const [items, setItems] = useState([]);
  const [help, setHelp] = useState([]);
  const [openIdx, setOpenIdx] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/faq"),
      api.get("/help"),
    ]).then(([{ data: f }, { data: h }]) => {
      setItems(f);
      setHelp(h);
      setLoading(false);
    });
  }, []);

  return (
    <Layout title="Aiuto & FAQ" subtitle="Documentazione completa, domande frequenti e guide rapide">
      {loading ? <Spinner /> : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <Card className="lg:col-span-2">
            <Label>Domande frequenti</Label>
            <div className="space-y-2 mt-2" data-testid="faq-list">
              {items.map((it, i) => (
                <div key={i} className="border border-zinc-200 rounded-sm" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                    className="w-full text-left px-4 py-3 flex items-start justify-between gap-3 hover:bg-zinc-50 transition-colors"
                  >
                    <div className="flex items-start gap-3 flex-1">
                      <Question weight="duotone" className="text-klein flex-shrink-0 mt-0.5" size={18} />
                      <span className="text-sm font-medium">{it.q}</span>
                    </div>
                    <CaretDown size={14} className={`text-zinc-400 transition-transform ${openIdx === i ? "rotate-180" : ""}`} />
                  </button>
                  {openIdx === i && (
                    <div className="px-4 pb-3 pl-12 text-sm text-zinc-700 leading-relaxed border-t border-zinc-100 pt-3 bg-zinc-50/50">
                      {it.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Card>

          <div className="space-y-4">
            <Card>
              <Label>Aiuto per pagina</Label>
              <div className="space-y-1 mt-2" data-testid="help-pages">
                {help.map((h) => (
                  <Link key={h.key} to={`/help/${h.key}`} className="flex items-center justify-between px-3 py-2 hover:bg-zinc-50 rounded-sm text-sm transition-colors" data-testid={`help-page-${h.key}`}>
                    <div className="flex items-center gap-2">
                      <BookOpen size={14} className="text-zinc-400" />
                      {h.title}
                    </div>
                    <ArrowRight size={12} className="text-zinc-400" />
                  </Link>
                ))}
              </div>
            </Card>

            <Card className="ai-panel">
              <Label>Hai bisogno di aiuto?</Label>
              <p className="text-sm text-zinc-700 mt-2">
                Contatta il supporto Like Digital S.r.l. all'indirizzo <strong>de.florentiis@likedigital.it</strong> per richieste tecniche.
              </p>
              <p className="text-xs text-zinc-600 mt-3">
                Per integrare portali custom, sviluppare adapter o esportare la piattaforma in standalone Docker,
                contatta il team di sviluppo (Prompt 34 del documento).
              </p>
            </Card>
          </div>
        </div>
      )}
    </Layout>
  );
}
